import { jsx as r } from "react/jsx-runtime";
import e from "../../utils/classNames.js";
const i = ({ className: s, children: t, ...a }) => {
  const o = e("ActionBarItemList", s);
  return /* @__PURE__ */ r("ul", { ...a, className: o, children: t });
};
export {
  i as default
};
//# sourceMappingURL=ActionBarItemList.js.map
